import { Toast } from 'antd-mobile'
import { useAtomValue } from 'jotai'
import qs from 'qs'
import { NavigateOptions, useNavigate } from 'react-router-dom'

import { loginStateAtom } from '@/store'
import { jumpMainLogin } from '@/utils'

export const useCustomNavigate = () => {
  const navigate = useNavigate()
  const isLogin = useAtomValue(loginStateAtom)

  /**
   * 自定义路由导航
   * @param path 路径
   * @param del 要删除的参数 string[] | string
   * @param options navigate原生配置对象
   * @returns
   */
  const customNavigator = async (path: string, del: string[] | string = '', options: NavigateOptions = {}) => {
    const channelSearch = sessionStorage.getItem('channelSearch') || ''
    const [basePath, baseSearch] = path.split('?')
    const baseParams = qs.parse(baseSearch)
    const channelParams = qs.parse(channelSearch.startsWith('?') ? channelSearch.slice(1) : channelSearch)

    let paramsString = qs.stringify({
      ...channelParams,
      ...baseParams,
    })

    paramsString = handleDelSearch(del, paramsString)

    const completePath = paramsString ? `${basePath}?${paramsString}` : basePath

    const GUARDIAN_PATH = ['/library', '/message', '/personal', '/rewards', '/publish']

    if ((!isLogin && GUARDIAN_PATH.includes(basePath)) || (!isLogin && basePath.includes('/detail/review'))) {
      // 调用全局登录弹窗
      await new Promise<void>((resloveFn) => {
        Toast.show({
          position: 'top',
          content: 'Login to continue',
          afterClose: resloveFn,
          duration: 1000,
        })
      })
      jumpMainLogin()

      return
    }
    return navigate(completePath, options)
  }

  const handleDelSearch = (del: string[] | string, paramsString: string) => {
    if (del === '') {
      return paramsString
    }

    const params = qs.parse(paramsString)
    if (Array.isArray(del)) {
      del.forEach((item) => {
        delete params[item]
      })
    }
    // 非数组
    if (del !== '') {
      delete params[del as string]
    }
    const sessionParams = qs.stringify(params)
    sessionStorage.setItem('channelSearch', sessionParams === '' ? '' : `?${sessionParams}`)
    return qs.stringify(params)
  }

  return { customNavigator }
}
